import angular from 'angular';

export default angular.module('location', ['ngMap'])
.directive('location', location);

location.$inject = [];

function location() {
	var directive = {
		link: link,
		restrict: 'A',
		scope: true
	};
	return directive;

	function link(scope) {
		scope.marker = {
			url: wp.template_directory_uri + '/public/assets/images/icons/map-pin.svg',
			scaledSize:[45,52.5],
			origin: [0,0],
			anchor: [22.5,52.5]
		};
	}
}



/** WEBPACK FOOTER **
 ** ./src/js/location/location.js
 **/